import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Tooltip as MuiTooltip, TooltipProps as MuiTooltipProps } from '@material-ui/core';

type CustomTooltipProps = {
  width?: string;
} & MuiTooltipProps;

const Tooltip = (props: CustomTooltipProps) => {
  const { children, width, ...restProps } = props;
  const useStyles = makeStyles({
    tooltip: {
      color: '#FFFFFF',
      backgroundColor: '#373D43',
      boxShadow: '0px 2px 16px rgba(0, 24, 26, 0.12)',
      borderRadius: '4px',
      width: width || 'auto',
      fontSize: 12
    },
    arrow: {
      color: '#373D43'
    }
  });

  const classes = useStyles();

  return (
    <MuiTooltip classes={{ tooltip: classes.tooltip, arrow: classes.arrow }} {...restProps}>
      {children}
    </MuiTooltip>
  );
};

export default Tooltip;
